export * from './icons';
export * from './components/twoTonePrimaryColor';
export { default as createFromIconfontCN } from './components/IconFont';
export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/index.js
// module id = 133
// module chunks = 0